var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPenaltyManagementFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.78 2H8.22C4.44 2 3.5 3.01 3.5 7.04V18.3C3.5 20.96 4.96 21.59 6.73 19.69L6.74 19.68C7.56 18.81 8.81 18.88 9.52 19.83L10.53 21.18C11.34 22.25 12.65 22.25 13.46 21.18L14.47 19.83C15.19 18.87 16.44 18.8 17.26 19.68C19.04 21.58 20.49 20.95 20.49 18.29V7.04C20.5 3.01 19.56 2 15.78 2ZM7.78 12C7.23 12 6.78 11.55 6.78 11C6.78 10.45 7.23 10 7.78 10C8.33 10 8.78 10.45 8.78 11C8.78 11.55 8.33 12 7.78 12ZM7.78 8C7.23 8 6.78 7.55 6.78 7C6.78 6.45 7.23 6 7.78 6C8.33 6 8.78 6.45 8.78 7C8.78 7.55 8.33 8 7.78 8ZM16.23 11.75H10.73C10.32 11.75 9.98 11.41 9.98 11C9.98 10.59 10.32 10.25 10.73 10.25H16.23C16.64 10.25 16.98 10.59 16.98 11C16.98 11.41 16.64 11.75 16.23 11.75ZM16.23 7.75H10.73C10.32 7.75 9.98 7.41 9.98 7C9.98 6.59 10.32 6.25 10.73 6.25H16.23C16.64 6.25 16.98 6.59 16.98 7C16.98 7.41 16.64 7.75 16.23 7.75Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6914 21.7188C19.9005 21.7188 21.6914 19.9279 21.6914 17.7188C21.6914 15.5096 19.9005 13.7188 17.6914 13.7188C15.4823 13.7188 13.6914 15.5096 13.6914 17.7188C13.6914 19.9279 15.4823 21.7188 17.6914 21.7188Z",
    fill: "#F0F0F0",
    stroke: "#292D32",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6914 15.7188V17.7188",
    stroke: "#292D32",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6914 19.9688C18.1056 19.9688 18.4414 19.633 18.4414 19.2188C18.4414 18.8045 18.1056 18.4688 17.6914 18.4688C17.2772 18.4688 16.9414 18.8045 16.9414 19.2188C16.9414 19.633 17.2772 19.9688 17.6914 19.9688Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenaltyManagementFill);
export default __webpack_public_path__ + "static/media/penalty-management-fill.9252de651c51111c6a028e4a2563def2.svg";
export { ForwardRef as ReactComponent };